export enum ProductMark {
  CEMark = 'CE_MARK',
  UKCAMark = 'UKCA_MARK',
}
